/*
 * @Author: bbqin
 * @Date: 2022-10-21 09:42:56
 * @LastEditTime: 2023-08-31 18:10:41
 * @LastEditors: bbqin
 * @Description: 如果我没写，可能我忘了。如果我忘了，可能我没看。如果我没看，可能我没写。
 * @FilePath: \Platform_Front\src\platform\components\MetaFieldSetting\setting\adapter\more\index.js
 * (混沌)足够多的方案才能接近真实的结果。
 */

import React, { Component } from "react";
// import Field from './field';
// import View from './view';
import { getSysFieldid } from '@platform/api';

require('./index.less');

class MoreSetting extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { code } = this.props;

        return <div
            className="core-setting-container"
            fieldid={getSysFieldid(`${code}_setting_area`)}
        >
            更多设置~~~
            {/* <Field {...this.props} />
            <View {...this.props} /> */}
        </div>;
    }
}

export default MoreSetting;
